module.exports = "/src/views/games/other/images/maps/mafia1.png";